export default __webpack_public_path__ + "static/media/Pickpocket's Jerkin of the Tenth Court.a39f1e10.jpg";